<mat-sidenav-container class="h-screen">
  <!-- Sidebar -->
  <mat-sidenav
    #sidenav
    mode="side"
    [opened]="true"
    class="!bg-white !border-r !border-gray-200 flex flex-col relative"
    [ngClass]="isSidebarCollapsed() ? '!w-[72px]' : '!w-[260px]'"
    [ngStyle]="{'transition': 'width 200ms ease'}">
    
    <!-- Logo -->
    <div class="flex items-center justify-start p-4 border-b border-gray-200 h-16">
      <div class="flex items-center text-primary font-semibold whitespace-nowrap overflow-hidden">
        <img 
          src="assets/images/labanca_logo-scaled.png" 
          alt="La Banca" 
          class="flex-shrink-0"
          [class.h-7]="isSidebarCollapsed()"
          [class.h-10]="!isSidebarCollapsed()"
          [class.w-auto]="true" />
      </div>
    </div>

    <!-- Navigation -->
    <mat-nav-list class="flex-1 p-2 overflow-y-auto">
      @for (item of navItems; track $index) {
        @if (item.type === 'section') {
          @if (isSidebarCollapsed()) {
            <mat-divider class="!my-2"></mat-divider>
          } @else {
            <div class="px-3 pt-4 pb-1">
              <span class="text-xs font-semibold text-gray-400 uppercase tracking-wider">{{ item.label }}</span>
            </div>
          }
        } @else {
          <a
            mat-list-item
            [routerLink]="item.route"
            routerLinkActive="!bg-primary !text-white"
            class="!rounded-lg !mb-1 text-gray-500 hover:!bg-gray-100"
            [class.!justify-center]="isSidebarCollapsed()"
            [class.!px-3]="isSidebarCollapsed()"
            [matTooltip]="isSidebarCollapsed() ? item.label : ''"
            matTooltipPosition="right">
            <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
            @if (!isSidebarCollapsed()) {
              <span matListItemTitle>{{ item.label }}</span>
            }
          </a>
        }
      }
    </mat-nav-list>

    <!-- User Section -->
    <div class="p-4 border-t border-gray-200">
      <div 
        class="flex items-center gap-3 cursor-pointer p-2 rounded-lg hover:bg-gray-100 transition-colors"
        [class.justify-center]="isSidebarCollapsed()"
        [matMenuTriggerFor]="userMenu">
        <div class="w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center font-semibold flex-shrink-0">
          {{ getUserInitial() }}
        </div>
        @if (!isSidebarCollapsed()) {
          <div class="flex flex-col overflow-hidden text-center">
            <span class="text-sm font-semibold text-gray-900 truncate">{{ username() }}</span>
            <span class="text-xs text-gray-500">Administrador</span>
          </div>
        }
      </div>
      <mat-menu #userMenu="matMenu">
        <button mat-menu-item (click)="logout()">
          <mat-icon>logout</mat-icon>
          <span>Cerrar Sesión</span>
        </button>
      </mat-menu>
    </div>
    <span class="border-t border-gray-200 p-4 text-xs text-gray-500 block text-center">Versión: {{version}}</span>
  </mat-sidenav>

  <!-- Main Content -->
  <mat-sidenav-content class="!bg-gray-50">
    <!-- Header Toolbar -->
    <mat-toolbar class="!bg-white !border-b !border-gray-200 !h-16">
      <button mat-icon-button class="md:!hidden" (click)="toggleSidebar()">
        <mat-icon>menu</mat-icon>
      </button>
      <span class="flex-1"></span>
      <button mat-icon-button matTooltip="Ayuda">
        <mat-icon>help</mat-icon>
      </button>
    </mat-toolbar>

    <!-- Page Content -->
    <div class="flex-1 p-6 overflow-x-hidden overflow-y-auto h-[calc(100vh-64px)]">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
